// Runtime config. The app runs on mock data by default so `pnpm web:dev` works with no
// backend; set VITE_USE_API=true (and provide an event via ?event=<slug>) to go live.

export const USE_API = import.meta.env.VITE_USE_API === "true";

/** API base — same-origin "/api" in dev (Vite proxies to the Worker) and in prod. */
export const API_BASE = import.meta.env.VITE_API_BASE ?? "";

/** The wedding event slug from the QR URL (?event=<slug>), defaulting to the demo. */
export function eventSlug(): string {
  const params = new URLSearchParams(window.location.search);
  return params.get("event") ?? "taner-and-abbie";
}
